import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
} from 'recompose';
import reactCSS from 'reactcss';
import { Settings } from '../settings';
import Header from '../header';
import CookieToggleGroup from '../cookie-toggle-group';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import { Container } from '@ux/grid';
import Submit, { Kind, Size } from '@ux/submit';
import { Content } from '@ux/typeface';
import { getStyles } from '@ux/style-utils';
import { withBreakpoints } from '@ux/responsive';
import stylesheet from './InlinePrivacy.stylesheet';
import * as r from 'ramda';
import PaddingBox, { Side } from '@ux/padding-box';

const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  tablet: props.isMinSm,
  pristine: r.pathEq([ 'form', 'pristine' ], true, props),
  submitSucceeded: r.pathEq([ 'form', 'submitSucceeded' ], true, props),
});

export const PureInlinePrivacy = ({
  theme,
  styles,
  isMinSm,
  isMinMd,
  isMinLg,
  cookies,
  privacyPolicyUrl,
  form,
}) => (
  <form onSubmit={form.handleSubmit}>
    <Content
      theme={theme}
      component="div"
      className="UPM__InlinePrivacy"
    >
      <style>
        {`
          .InlinePrivacy * {
            box-sizing: border-box;
          }
        `}
      </style>
      <PaddingBox
        theme={theme}
        side={Side.X}
      >
        <div style={styles.header}>
          <Header
            theme={theme}
            intlNamespace="inline"
            privacyPolicyUrl={privacyPolicyUrl}
          />
          <span style={styles.save}>
            <Submit
              theme={theme}
              kind={Kind.POSITIVE}
              size={Size.MD}
              block={!isMinSm}
              formProps={form}
            >
              <CascadingFormattedMessage
                cascade={[
                  {
                    id: 'cookie.save',
                  },
                  {
                    id: 'cookie.confirm',
                  },
                ]}
              />
            </Submit>
          </span>
        </div>
      </PaddingBox>
      <Settings
        theme={theme}
        expanded={true}
        isMinSm={isMinSm}
        isMinMd={isMinMd}
      >
        <CookieToggleGroup
          theme={theme}
          cookies={cookies}
          isMinSm={isMinSm}
          isMinMd={isMinMd}
          isMinLg={isMinLg}
        />
      </Settings>
    </Content>
  </form>
);

export const enhance = compose(
  setDisplayName('InlinePrivacy'),
  withBreakpoints,
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureInlinePrivacy);
